import UserList from '../components/UserList';

export default function Users() {
	return <UserList />;
}
